import React from 'react';
import "../App.css";
import axios from "axios";
import { ReactTransliterate } from "react-transliterate";
import "react-transliterate/dist/index.css";
import NavFormProfile from './NavFormProfile';
import AdminNavFormProfile from './AdminNavFormProfile';

import Path from "./config";
//import { Link } from "react-router-dom";
class PersonalInfo extends React.Component {
    constructor(props) {
        super(props);
        //for radio onchange
        //this.showScanType = this.showScanType.bind(this);

        this.state = {
            bloodGroupSelect: [],
            varnaSelect: [],
            zediocList: [],
            gotremList: [],
            mangalList: [],
            maritualStatus: [],
            heightList: [],
            adminid: '',
            apekshaLength: '0',
            monthList: [
                { mid: "01", mname: "January" },
                { mid: "02", mname: "February" },
                { mid: "03", mname: "March" },
                { mid: "04", mname: "April" },
                { mid: "05", mname: "May" },
                { mid: "06", mname: "June" },
                { mid: "07", mname: "July" },
                { mid: "08", mname: "August" },
                { mid: "09", mname: "September" },
                { mid: "10", mname: "October" },
                { mid: "11", mname: "November" },
                { mid: "12", mname: "December" }
            ],
            sbg_birth_min: '',
            sbg_birth_am: '',
            sbg_first_name: '',
            sbg_middle_name: '',
            sbg_last_name: '',
            sbg_mulgav: '',
            sbg_sex: '',
            sbg_bloodgroup_id: '',
            sbg_birth_name: '',
            sbg_birth_place: '',
            sbg_birth_date: '',
            sbg_birth_time: '',
            sbg_skin_complexion_id: '',
            sbg_zodiac_signs_id: '',
            sbg_height_id: '',
            sbg_gotra_id: '',
            sbg_mama_kul: '',
            sbg_mama_place: '',
            sbg_marital_status_id: '',
            sbg_handicapped: '',
            sbg_mangal_status_id: '',
            sbg_birth_year: '',
            sbg_birth_month: '',
            sbg_expectation: '',
            userId: null,

            sbg_gh_marriage_date: '',
            sbg_gh_vibhakta_date: '',
            sbg_gh_divorce_date: '',
            sbg_aptya_girl_no: '',
            sbg_aptya_girl_age: '',
            sbg_aptya_boy_no: '',
            sbg_aptya_boy_age: '',
            sbg_eng_first_name: '',
            sbg_eng_middle_name: '',
            sbg_eng_sirname: '',
            aaptyaDiv: false,
            ghatspotDiv: false,
            vidhvaDateDiv: false,
            VibhktaDateDiv: false,
            vivahDateDiv: false,
            NavMenu: false

        }
    }
    nameHandler = (e) => {
        document.getElementById("sbg_first_name").style.borderColor = "";
        let data = e.target.value;
        if (data.length > 20) {

        } else {
            this.setState
                ({ sbg_first_name: e.target.value })
        }
    }

    middlenameHandler = (e) => {
        document.getElementById("sbg_middle_name").style.borderColor = "";
        let data = e.target.value;
        if (data.length > 20) {

        } else {
            this.setState
                ({ sbg_middle_name: e.target.value })
        }
    }
    lastnameHandler = (e) => {
        let data = e.target.value;
        if (data.length > 20) {

        } else {
            document.getElementById("sbg_last_name").style.borderColor = "";
            this.setState
                ({ sbg_last_name: e.target.value })
        }
    }

    engnameHandler = (e) => {
        document.getElementById("sbg_eng_first_name").style.borderColor = "";


        let data = e.target.value;
        if (data.length > 20) {

        } else {
            this.setState
                ({ sbg_eng_first_name: e.target.value })
        }
    }

    engmiddlenameHandler = (e) => {
        document.getElementById("sbg_eng_middle_name").style.borderColor = "";

        let data = e.target.value;
        if (data.length > 20) {

        } else {
            this.setState
                ({ sbg_eng_middle_name: e.target.value })
        }
    }
    englastnameHandler = (e) => {
        document.getElementById("sbg_eng_sirname").style.borderColor = "";


        let data = e.target.value;
        if (data.length > 20) {

        } else {
            this.setState
                ({ sbg_eng_sirname: e.target.value })
        }
    }


    mulgavHandler = (e) => {
        document.getElementById("sbg_mulgav").style.borderColor = "";

        let data = e.target.value;
        if (data.length > 20) {

        } else {
            this.setState
                ({ sbg_mulgav: e.target.value })
        }
    }
    bldgrpHandler = (e) => {
        document.getElementById("sbg_bloodgroup_id").style.borderColor = "";
        this.setState
            ({ sbg_bloodgroup_id: e.target.value })
    }
    birthnameHandler = (e) => {
        document.getElementById("sbg_birth_name").style.borderColor = "";


        let data = e.target.value;
        if (data.length > 20) {

        } else {
            this.setState
                ({ sbg_birth_name: e.target.value })
        }
    }
    birthplaceHandler = (e) => {
        document.getElementById("sbg_birth_place").style.borderColor = "";


        let data = e.target.value;
        if (data.length > 20) {

        } else {
            this.setState
                ({ sbg_birth_place: e.target.value })
        }
    }
    bdateHandler = (e) => {
        this.setState
            ({ sbg_birth_date: e.target.value })
    }
    btimeHandler = (e) => {
        this.setState
            ({ sbg_birth_time: e.target.value })
    }
    btimeamHandler = (e) => {
        this.setState
            ({ sbg_birth_am: e.target.value })
    }
    skinHandler = (e) => {
        document.getElementById("sbg_skin_complexion_id").style.borderColor = "";
        this.setState
            ({ sbg_skin_complexion_id: e.target.value })
    }

    zodiacHandler = (e) => {
        document.getElementById("sbg_zodiac_signs_id").style.borderColor = "";
        this.setState
            ({ sbg_zodiac_signs_id: e.target.value })
    }
    heightHandler = (e) => {
        document.getElementById("sbg_height_id").style.borderColor = "";
        this.setState
            ({ sbg_height_id: e.target.value })
    }
    gotraHandler = (e) => {
        document.getElementById("sbg_gotra_id").style.borderColor = "";
        this.setState
            ({ sbg_gotra_id: e.target.value })
    }
    kulHandler = (e) => {
        document.getElementById("sbg_mama_kul").style.borderColor = "";


        let data = e.target.value;
        if (data.length > 25) {

        } else {
            this.setState
                ({ sbg_mama_kul: e.target.value })
        }
    }
    mplaceHandler = (e) => {
        document.getElementById("sbg_mama_place").style.borderColor = "";


        let data = e.target.value;
        if (data.length > 20) {

        } else {
            this.setState
                ({ sbg_mama_place: e.target.value })
        }
    }


    mrstatusHandler = (e) => {
        document.getElementById("sbg_marital_status_id").style.borderColor = "";
        this.setState
            ({ sbg_marital_status_id: e.target.value }, () => {

                //console.log(this.state.sbg_marital_status_id);

                if (this.state.sbg_marital_status_id === "1") {
                    this.setState({
                        aaptyaDiv: false,
                        ghatspotDiv: false,
                        vidhvaDateDiv: false,
                        VibhktaDateDiv: false,
                        vivahDateDiv: false,
                    })
                }
                else if (this.state.sbg_marital_status_id === "2") {
                    this.setState({
                        aaptyaDiv: true,
                        ghatspotDiv: true,
                        vidhvaDateDiv: false,
                        VibhktaDateDiv: true,
                        vivahDateDiv: true,
                    })
                }
                else if (this.state.sbg_marital_status_id === "3") {
                    this.setState({
                        aaptyaDiv: true,
                        ghatspotDiv: false,
                        vidhvaDateDiv: true,
                        VibhktaDateDiv: false,
                        vivahDateDiv: true,
                    })
                }
                else if (this.state.sbg_marital_status_id === "4") {
                    this.setState({
                        aaptyaDiv: true,
                        ghatspotDiv: false,
                        vidhvaDateDiv: false,
                        VibhktaDateDiv: true,
                        vivahDateDiv: true,
                    })
                }
                else if (this.state.sbg_marital_status_id === "5") {
                    this.setState({
                        aaptyaDiv: false,
                        ghatspotDiv: true,
                        vidhvaDateDiv: false,
                        VibhktaDateDiv: true,
                        vivahDateDiv: true,
                    })
                }
            }
            )

    }




    handicapHandler = (e) => {
        document.getElementById("sbg_handicapped").style.borderColor = "";


        let data = e.target.value;
        if (data.length > 80) {

        } else {
            this.setState
                ({ sbg_handicapped: e.target.value })
        }


    }
    mangalstausHandler = (e) => {
        document.getElementById("sbg_mangal_status_id").style.borderColor = "";
        this.setState
            ({ sbg_mangal_status_id: e.target.value })
    }
    byearHandler = (e) => {
        this.setState
            ({ sbg_birth_year: e.target.value })
    }
    bmonthHandler = (e) => {
        this.setState
            ({ sbg_birth_month: e.target.value })
    }
    genderHandler = (e) => {
        this.setState
            ({ sbg_sex: e.target.value })
    }




    ghMarriageDateHandler = (e) => {
        this.setState
            ({ sbg_gh_marriage_date: e.target.value })
    }
    vibhaktaDateHandler = (e) => {
        this.setState
            ({ sbg_gh_vibhakta_date: e.target.value })
    }
    ghatspotHandler = (e) => {
        this.setState
            ({ sbg_gh_divorce_date: e.target.value })
    }
    aptyaGirlNoHandler = (e) => {
        const re = /^[0-9\b]+$/;
        if (e.target.value === '' || re.test(e.target.value)) {
            this.setState({ sbg_aptya_girl_no: e.target.value })
        }

    }
    aptyaGirlAgeHandler = (e) => {

        this.setState({ sbg_aptya_girl_age: e.target.value })



    }
    aptyaBoyNoHandler = (e) => {
        const re = /^[0-9\b]+$/;
        if (e.target.value === '' || re.test(e.target.value)) {
            this.setState({ sbg_aptya_boy_no: e.target.value })


        }

    }
    aptyaBoyAgeHandler = (e) => {
        this.setState({ sbg_aptya_boy_age: e.target.value })

    }
    vidhvaHandler = (e) => {
        this.setState
            ({ sbg_vidhva_date: e.target.value })
    }


    btimeminHandler = (e) => { this.setState({ sbg_birth_min: e.target.value }) }

    expectationHandler = (e) => {
        document.getElementById("sbg_expectation").style.borderColor = "";
        let data = e.target.value;
        if (data.length > 100) {
            // this.setState({ sbg_expectation:'',  })
        }
        else { this.setState({ sbg_expectation: e.target.value, apekshaLength: data.length }) }
        // this.setState({ sbg_expectation:e.target.value , apekshaLength:data.length });
        //  document.getElementById('dataLimit').innerHTML = data.length 
        //console.log("limit ",data.length );

    }

    componentDidMount() {
        this.setState({
            userId: localStorage.getItem("userId"),
            admin: localStorage.getItem("admin"),
            adminid: localStorage.getItem("userId")
        })

        if (localStorage.getItem("admin") === "Admin") {
            this.setState({
                NavMenu: true
            })
        }


        axios.get(Path + 'Suchi_Bride_Groom_showinfo.php?sbg_id=' + localStorage.getItem("userId"))
            .then(function (response) {
                // handle success
                //console.log("rrrrrrrrrrrrrrrrrrrrrr",response.data);
                //   data=response.data;
                response = response.data;
                if (response) {
                    var array = response.sbg_birth_date.split("-");
                    var array1 = response.sbg_birth_time.split(":");
                }

                // console.log("arrrrrrrrrr",array1[0])

                if (response.sbg_marital_status_id === "1") {
                    this.setState({
                        aaptyaDiv: false,
                        ghatspotDiv: false,
                        vidhvaDateDiv: false,
                        VibhktaDateDiv: false,
                        vivahDateDiv: false,
                    })
                }
                else if (response.sbg_marital_status_id === "2") {
                    this.setState({
                        aaptyaDiv: true,
                        ghatspotDiv: true,
                        vidhvaDateDiv: false,
                        VibhktaDateDiv: true,
                        vivahDateDiv: true,
                    })
                }
                else if (response.sbg_marital_status_id === "3") {
                    this.setState({
                        aaptyaDiv: true,
                        ghatspotDiv: false,
                        vidhvaDateDiv: true,
                        VibhktaDateDiv: false,
                        vivahDateDiv: true,
                    })
                }
                else if (response.sbg_marital_status_id === "4") {
                    this.setState({
                        aaptyaDiv: true,
                        ghatspotDiv: false,
                        vidhvaDateDiv: false,
                        VibhktaDateDiv: true,
                        vivahDateDiv: true,
                    })
                }
                else if (response.sbg_marital_status_id === "5") {
                    this.setState({
                        aaptyaDiv: false,
                        ghatspotDiv: true,
                        vidhvaDateDiv: false,
                        VibhktaDateDiv: true,
                        vivahDateDiv: true,
                    })
                }
                // if(response.sbg_payment_status !== "1")
                // { 
                //     this.props.history.push(`/`);
                // }

                this.setState({

                    sbg_first_name: response.sbg_first_name,
                    sbg_middle_name: response.sbg_middle_name,
                    sbg_last_name: response.sbg_last_name,
                    sbg_mulgav: response.sbg_mulgav,
                    sbg_sex: response.sbg_sex,
                    sbg_bloodgroup_id: response.sbg_bloodgroup_id,
                    sbg_birth_name: response.sbg_birth_name,
                    sbg_birth_place: response.sbg_birth_place,

                    sbg_birth_year: array[0],
                    sbg_birth_month: array[1],
                    sbg_birth_date: array[2],
                    sbg_birth_time: array1[0],
                    sbg_birth_min: array1[1],
                    sbg_birth_am: array1[2],
                    sbg_skin_complexion_id: response.sbg_skin_complexion_id,
                    sbg_zodiac_signs_id: response.sbg_zodiac_signs_id,
                    sbg_height_id: response.sbg_height_id,
                    sbg_gotra_id: response.sbg_gotra_id,
                    sbg_mama_kul: response.sbg_mama_kul,
                    sbg_mama_place: response.sbg_mama_place,
                    sbg_marital_status_id: response.sbg_marital_status_id,
                    sbg_handicapped: response.sbg_handicapped,
                    sbg_mangal_status_id: response.sbg_mangal_status_id,
                    sbg_expectation: response.sbg_expectation,
                    apekshaLength: response.sbg_expectation.length,
                    sbg_gh_marriage_date: response.sbg_gh_marriage_date,
                    sbg_gh_vibhakta_date: response.sbg_gh_vibhakta_date,
                    sbg_gh_divorce_date: response.sbg_gh_divorce_date,
                    sbg_vidhva_date: response.sbg_vidhva_date,
                    sbg_aptya_girl_no: response.sbg_aptya_girl_no,
                    sbg_aptya_girl_age: response.sbg_aptya_girl_age,
                    sbg_aptya_boy_no: response.sbg_aptya_boy_no,
                    sbg_aptya_boy_age: response.sbg_aptya_boy_age,
                    sbg_eng_first_name: response.sbg_eng_first_name,
                    sbg_eng_middle_name: response.sbg_eng_middle_name,
                    sbg_eng_sirname: response.sbg_eng_sirname
                })
            }.bind(this))
        // ********************** bloodGroupSelect ************************
        axios.get(Path + 'bloodgroupList.php')
            .then(function (response) {
                //console.log("rrrrrrrrrrrrrrrrrrrrrr",response.data);
                this.setState({ bloodGroupSelect: response.data.bg_bloodgroup })
            }.bind(this))

        // ********************** varnaSelect ************************
        axios.get(Path + 'skinColorList.php')
            .then(function (response) {
                //console.log("rrrrrrrrrrrrrrrrrrrrrr",response.data);
                this.setState({ varnaSelect: response.data.bg_color })
            }.bind(this))

        // ********************** zediocList ************************
        axios.get(Path + 'zodicSignList.php')
            .then(function (response) {
                //console.log("rrrrrrrrrrrrrrrrrrrrrr",response.data);
                this.setState({ zediocList: response.data.bg_zodiacsign })
            }.bind(this))

        // ********************** gotremList ************************
        axios.get(Path + 'suchi_gotremList.php')
            .then(function (response) {
                //console.log("rrrrrrrrrrrrrrrrrrrrrr",response.data);
                this.setState({ gotremList: response.data.bg_gotra })
            }.bind(this))

        // ********************** mangalList ************************
        axios.get(Path + 'mangalList.php')
            .then(function (response) {
                //console.log("rrrrrrrrrrrrrrrrrrrrrr",response.data);
                this.setState({ mangalList: response.data.bg_magal })
            }.bind(this))

        // ********************** maritualStatus ************************
        axios.get(Path + 'maratialStatusList.php')
            .then(function (response) {
                //console.log("rrrrrrrrrrrrrrrrrrrrrr",response.data);
                this.setState({ maritualStatus: response.data.bg_marital_status })
            }.bind(this))

        // ********************** heightList ************************
        axios.get(Path + 'heightList.php')
            .then(function (response) {
                //console.log("rrrrrrrrrrrrrrrrrrrrrr",response.data);
                this.setState({ heightList: response.data.bg_height })
            }.bind(this))




            .catch(function (error) {
                // handle error
                console.log(error);
            })
            .then(function () {
                // always executed
            });




    }

    submitClick = (e) => {
        let isValid = true;

        if (this.state.sbg_first_name === "") {
            document.getElementById("sbg_first_name").style.borderColor = "red";
            isValid = false;
        }

        if (this.state.sbg_middle_name === "") {
            document.getElementById("sbg_middle_name").style.borderColor = "red";
            isValid = false;
        }

        if (this.state.sbg_last_name === "") {
            document.getElementById("sbg_last_name").style.borderColor = "red";
            isValid = false;
        }


        if (this.state.sbg_mulgav === "") {
            document.getElementById("sbg_mulgav").style.borderColor = "red";
            isValid = false;
        }


        if (this.state.sbg_birth_name === "") {
            document.getElementById("sbg_birth_name").style.borderColor = "red";
            isValid = false;
        }


        if (this.state.sbg_birth_place === "") {
            document.getElementById("sbg_birth_place").style.borderColor = "red";
            isValid = false;
        }

        if (this.state.sbg_mama_kul === "") {
            document.getElementById("sbg_mama_kul").style.borderColor = "red";
            isValid = false;
        }

        if (this.state.sbg_mama_place === "") {
            document.getElementById("sbg_mama_place").style.borderColor = "red";
            isValid = false;
        }

        if (this.state.sbg_expectation === "") {
            document.getElementById("sbg_expectation").style.borderColor = "red";
            isValid = false;
        }

        if (this.state.sbg_eng_first_name === "") {
            document.getElementById("sbg_eng_first_name").style.borderColor = "red";
            isValid = false;
        }

        if (this.state.sbg_eng_middle_name === "") {
            document.getElementById("sbg_eng_middle_name").style.borderColor = "red";
            isValid = false;
        }

        if (this.state.sbg_eng_sirname === "") {
            document.getElementById("sbg_eng_sirname").style.borderColor = "red";
            isValid = false;
        }


        if (this.state.sbg_expectation === "") {
            document.getElementById("sbg_expectation").style.borderColor = "red";
            isValid = false;
        }



        if (this.state.sbg_bloodgroup_id === "0" || this.state.sbg_bloodgroup_id === "f") {
            document.getElementById("sbg_bloodgroup_id").style.borderColor = "red";
            isValid = false;
        }


        if (this.state.sbg_birth_date === "00" || this.state.sbg_birth_date === "DD") {
            document.getElementById("sbg_birth_date").style.borderColor = "red";
            isValid = false;
        }


        if (this.state.sbg_birth_month === "00" || this.state.sbg_birth_month === "MM") {
            document.getElementById("sbg_birth_month").style.borderColor = "red";
            isValid = false;
        }

        if (this.state.sbg_birth_year === "0000" || this.state.sbg_birth_year === "YY") {
            document.getElementById("sbg_birth_year").style.borderColor = "red";
            isValid = false;
        }


        if (this.state.sbg_birth_time === "" || this.state.sbg_birth_time === "hr") {
            document.getElementById("sbg_birth_time").style.borderColor = "red";
            isValid = false;
        }

        // console.log("sbg_birth_min", this.state.sbg_birth_min)
        if (this.state.sbg_birth_min == undefined || this.state.sbg_birth_min === "min") {
            document.getElementById("sbg_birth_min").style.borderColor = "red";
            isValid = false;
        }

        // console.log("sbg_birth_min", this.state.sbg_birth_amsbg_birth_min)
        if (this.state.sbg_birth_am === "am" || this.state.sbg_birth_am === undefined) {
            document.getElementById("sbg_birth_am").style.borderColor = "red";
            isValid = false;
        }

        if (this.state.sbg_skin_complexion_id === "0" || this.state.sbg_skin_complexion_id === "f") {
            document.getElementById("sbg_skin_complexion_id").style.borderColor = "red";
            isValid = false;
        }


        if (this.state.sbg_zodiac_signs_id === "0" || this.state.sbg_zodiac_signs_id === "f") {
            document.getElementById("sbg_zodiac_signs_id").style.borderColor = "red";
            isValid = false;
        }


        if (this.state.sbg_height_id === "0" || this.state.sbg_height_id === "f") {
            document.getElementById("sbg_height_id").style.borderColor = "red";
            isValid = false;
        }

        if (this.state.sbg_gotra_id === "0" || this.state.sbg_gotra_id === "f") {
            document.getElementById("sbg_gotra_id").style.borderColor = "red";
            isValid = false;
        }

        if (this.state.sbg_marital_status_id === "0" || this.state.sbg_marital_status_id === "f") {
            document.getElementById("sbg_marital_status_id").style.borderColor = "red";
            isValid = false;
        }


        e.preventDefault();

        let sbg_birth_date = this.state.sbg_birth_year + "-" + this.state.sbg_birth_month + "-" + this.state.sbg_birth_date;
        let sbg_birth_time = this.state.sbg_birth_time + ":" + this.state.sbg_birth_min + ":" + this.state.sbg_birth_am;
        let typee = "personal";
        let tempStr = "sbg_first_name=" + this.state.sbg_first_name +
            "&sbg_middle_name=" + this.state.sbg_middle_name +
            "&sbg_last_name=" + this.state.sbg_last_name +
            "&sbg_mulgav=" + this.state.sbg_mulgav +
            "&sbg_sex=" + this.state.sbg_sex +
            "&sbg_bloodgroup_id=" + this.state.sbg_bloodgroup_id +
            "&sbg_birth_name=" + this.state.sbg_birth_name +
            "&sbg_birth_place=" + this.state.sbg_birth_place +
            "&sbg_birth_date=" + sbg_birth_date +
            "&sbg_birth_time=" + sbg_birth_time +
            "&sbg_skin_complexion_id=" + this.state.sbg_skin_complexion_id +
            "&sbg_zodiac_signs_id=" + this.state.sbg_zodiac_signs_id +
            "&sbg_height_id=" + this.state.sbg_height_id +
            "&sbg_gotra_id=" + this.state.sbg_gotra_id +
            "&sbg_mama_kul=" + this.state.sbg_mama_kul +
            "&sbg_mama_place=" + this.state.sbg_mama_place +
            "&sbg_marital_status_id=" + this.state.sbg_marital_status_id +
            "&sbg_handicapped=" + this.state.sbg_handicapped +
            "&sbg_mangal_status_id=" + this.state.sbg_mangal_status_id +
            "&sbg_expectation=" + this.state.sbg_expectation +
            "&sbg_id=" + this.state.userId +
            "&sbg_vidhva_date=" + this.state.sbg_vidhva_date +
            "&sbg_gh_marriage_date=" + this.state.sbg_gh_marriage_date +
            "&sbg_gh_vibhakta_date=" + this.state.sbg_gh_vibhakta_date +
            "&sbg_gh_divorce_date=" + this.state.sbg_gh_divorce_date +
            "&sbg_aptya_girl_no=" + this.state.sbg_aptya_girl_no +
            "&sbg_aptya_girl_age=" + this.state.sbg_aptya_girl_age +
            "&sbg_aptya_boy_no=" + this.state.sbg_aptya_boy_no +
            "&sbg_aptya_boy_age=" + this.state.sbg_aptya_boy_age +
            "&sbg_eng_first_name=" + this.state.sbg_eng_first_name +
            "&sbg_eng_middle_name=" + this.state.sbg_eng_middle_name +
            "&sbg_eng_sirname=" + this.state.sbg_eng_sirname +

            "&type=" + typee

        //console.log(tempStr)

        if (isValid === true) {
            axios.post(Path + `Suchi_Bride_Groom_update.php?` + tempStr)
                .then(function (response) {
                    if (response.data.status === "updated") {
                        if (this.state.admin === "Admin") {
                            this.props.history.push(`/AdminProfile/EducationInfo`);
                        } else {
                            this.props.history.push(`/FormProfile/EducationInfo`);
                        }

                    }

                }.bind(this))
        }
        else {
            //alert ("Please fill up all compalsary fields");
            document.getElementById("error").innerHTML = "कृपया अनिवार्य माहिती पूर्ण भरावी.";
        }

    }
    render() {

        //console.log("date",this.state.sbg_birth_date)

        let BloodGroupList = this.state.bloodGroupSelect.map((bloodg, index) => {
            const { bb_id, b_bloodgroup } = bloodg //destructuring
            return (

                <option key={bb_id} value={bb_id}> {b_bloodgroup} </option>

            )
        })

        let varnaList = this.state.varnaSelect.map((varna, index) => {
            const { bc_id, e_bc_color } = varna //destructuring
            return (

                <option key={bc_id} value={bc_id}> {e_bc_color} </option>

            )
        })

        let zediocListItem = this.state.zediocList.map((zedioc, index) => {
            const { bz_id, e_bz } = zedioc //destructuring
            return (

                <option key={bz_id} value={bz_id}> {e_bz} </option>

            )
        })

        let gotremListItem = this.state.gotremList.map((gotra, index) => {
            const { bg_gotra_id, e_bg_gotra_name } = gotra //destructuring
            return (

                <option key={bg_gotra_id} value={bg_gotra_id}> {e_bg_gotra_name} </option>

            )
        })

        let mangalListItem = this.state.mangalList.map((mangal, index) => {
            const { bm_id, bm_type } = mangal //destructuring
            return (

                <option key={bm_id} value={bm_id}> {bm_type} </option>

            )
        })

        let maritualList = this.state.maritualStatus.map((marit, index) => {
            const { bms_id, e_bms_status } = marit //destructuring
            return (

                <option key={bms_id} value={bms_id}> {e_bms_status} </option>

            )
        })

        let heightListList = this.state.heightList.map((heightl, index) => {
            const { bh_id, e_bh_height } = heightl //destructuring
            return (

                <option key={bh_id} value={bh_id}> {e_bh_height} </option>

            )
        })

        let monthListItem = this.state.monthList.map((item, i) => {
            return (

                <option key={item.mid} value={item.mid}>{item.mname}</option>
            )
        })

        let yearr = [];
        for (var i = 1960; i < 2007; i++) {
            yearr.push(<option key={i} value={i}>{i}</option>);
        }

        let datee = [];
        for (var m = "1"; m < 32; m++) {
            if (m < 10) {
                m = "0" + m;
            }
            datee.push(<option key={m} value={m}>{m}</option>);
        }

        let timee = [];
        for (var n = 1; n <= 12; n++) {
            if (n < 10) {
                n = `0${n}`
            }
            else {
                n = `${n}`;
            }
            timee.push(<option key={n} value={n}>{n}</option>);
        }

        let minutee = [];
        for (var x = 0; x < 60; x++) {
            if (x < 10) {
                x = `0${x}`
            }
            else {
                x = `${x}`;
            }
            minutee.push(<option key={x} value={x}>{x}</option>);
        }

        return (
            <>
                {this.state.NavMenu ? <AdminNavFormProfile /> :
                    <NavFormProfile />}
                {/* <ReactTransliterate className="form-control"  value={this.state.sbg_first_name} lang="mr" onChange={this.nameHandler} /> */}
                {/* <div className="mt-4 font-weight-bold text-success text-center" >
                    <h5>
                        <Link to="./Guidlines"> फॉर्म भरतांना सोयीचे व्हावे म्हणून काही गाईडलाईन आहेत त्या वाचूनच फॉर्म भरावा.</Link>
                    </h5>SUBSCRIBE </div> */}

                <div className="m-5 pt-3" >




                    <form className="row g-3">
                        <div className="col-md-4">
                            <label htmlFor="inputEmail4" className="form-label">*  वधू/वराचे नाव (फक्त इंग्रजीत )</label>
                            <input type="text" className="form-control" id="sbg_eng_first_name" value={this.state.sbg_eng_first_name} onChange={this.engnameHandler} />
                        </div>
                        <div className="col-md-4">
                            <label htmlFor="putPassword4" className="form-label">*  वडिलांचे नाव (फक्त इंग्रजीत )</label>
                            <input type="text" value={this.state.sbg_eng_middle_name} id="sbg_eng_middle_name" onChange={this.engmiddlenameHandler} className="form-control" required />
                        </div>
                        <div className="col-md-4">
                            <label htmlFor="putPassword4" className="form-label">* आडनाव (फक्त इंग्रजीत ) </label>
                            <input type="text" id="sbg_eng_sirname" value={this.state.sbg_eng_sirname} onChange={this.englastnameHandler} className="form-control" required />
                        </div>
                        <div className="col-md-12 font-weight-bold mt2 mb2">
                            टीप :  आता या पुढील फॉर्म मराठीत भरायचा आहे
                        </div>
                        <div className="col-md-4">
                            <label htmlFor="inputEmail4" className="form-label">* वधू/वराचे  नाव </label>
                            <ReactTransliterate maxLength="20" className="form-control" id="sbg_first_name" value={this.state.sbg_first_name} lang="mr" onChange={this.nameHandler} placeholder="फक्त वधू /वराचे नाव टाकावे " />
                        </div>
                        <div className="col-md-4">
                            <label htmlFor="putPassword4" className="form-label">* वडिलांचे नाव </label>
                            <ReactTransliterate maxLength="20" id="sbg_middle_name" value={this.state.sbg_middle_name} onChange={this.middlenameHandler} className="form-control" required placeholder="फक्त वडिलांचे नाव टाकावे " />
                        </div>
                        <div className="col-md-4">
                            <label htmlFor="putPassword4" className="form-label">* आडनाव </label>
                            <ReactTransliterate id="sbg_last_name" value={this.state.sbg_last_name} onChange={this.lastnameHandler} className="form-control" required placeholder="फक्त आडनाव टाकावे " />
                        </div>

                        <div className="col-md-3">
                            <label htmlFor="putEmail4" className="form-label">* मुळगाव </label>
                            <ReactTransliterate id="sbg_mulgav" placeholder='मुळगाव' value={this.state.sbg_mulgav} onChange={this.mulgavHandler} className="form-control" required />
                        </div>
                        <div className="col-md-3">
                            <label htmlFor="putPassword4" className="form-label"> * लिंग </label> <br></br>
                            <div className="form-check form-check-inline">
                                <input name="sbg_sex" id="" value="Male" checked={this.state.sbg_sex === 'Male'} onChange={this.genderHandler} className="form-check-input" type="radio" />
                                <label className="form-check-label" htmlFor="lineRadio1">पुरुष </label>
                            </div>
                            <div className="form-check form-check-inline">
                                <input name="sbg_sex" id="" value="Female" checked={this.state.sbg_sex === 'Female'} onChange={this.genderHandler} className="form-check-input" type="radio" />
                                <label className="form-check-label" htmlFor="lineRadio2">स्त्री </label>
                            </div>

                        </div>
                        <div className="col-md-3">
                            <label htmlFor="putPassword4" className="form-label">रक्त गट  </label>
                            <select id="sbg_bloodgroup_id" value={this.state.sbg_bloodgroup_id} onChange={this.bldgrpHandler} className="form-select">
                                <option value="f" selected >Choose...</option>
                                {BloodGroupList}
                            </select>
                        </div>
                        <div className="col-md-3">
                            <label htmlFor="putState" className="form-label">* जन्म नाव </label>
                            <ReactTransliterate id="sbg_birth_name" placeholder='जन्म नाव ' value={this.state.sbg_birth_name} onChange={this.birthnameHandler} className="form-control" required />
                        </div>
                        <div className="col-md-4">
                            <label htmlFor="putState" className="form-label">* जन्म ठिकाण  </label>
                            <ReactTransliterate id="sbg_birth_place" placeholder='जन्म ठिकाण ' value={this.state.sbg_birth_place} onChange={this.birthplaceHandler} className="form-control" required />
                        </div>
                        <div className="col-md-4">
                            <label htmlFor="putState" className="form-label">* जन्म दिनांक </label>
                            <br></br>
                            <table width="100%">
                                <tbody>
                                    <tr>
                                        <td>
                                            <select style={{ width: "100%" }} id="sbg_birth_date" value={this.state.sbg_birth_date} onChange={this.bdateHandler} className="date_combo form-select " required>
                                                <option value="DD" selected>DD</option>
                                                {datee}
                                            </select>
                                        </td>
                                        <td>

                                            <select style={{ width: "100%" }} id="sbg_birth_month" value={this.state.sbg_birth_month} onChange={this.bmonthHandler} className="date_combo form-select " required>
                                                <option value="MM" selected>MM</option>
                                                {monthListItem}
                                            </select>
                                        </td>
                                        <td>

                                            <select style={{ width: "100%" }} id="sbg_birth_year" value={this.state.sbg_birth_year} onChange={this.byearHandler} className="date_combo form-select " required>
                                                <option value="YY" selected>YY</option>
                                                {yearr}
                                            </select>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>




                        </div>
                        <div className="col-md-4">
                            <label htmlFor="putState" className="form-label">* जन्म वेळ </label>
                            <br></br>

                            {/* <ReactTransliterate id="" value={this.state.sbg_birth_time} onChange={this.btimeHandler} className="txt_box"  /> */}

                            <table width="100%">
                                <tbody>
                                    <tr>
                                        <td>
                                            <select style={{ width: "100%" }} id="sbg_birth_time" value={this.state.sbg_birth_time} onChange={this.btimeHandler} className="date_combo form-select" required>
                                                <option value="hr" selected>hr</option>
                                                {timee}
                                            </select>
                                        </td>
                                        <td>
                                            <select style={{ width: "100%" }} id="sbg_birth_min" value={this.state.sbg_birth_min} onChange={this.btimeminHandler} className="date_combo form-select" required>
                                                <option value="min" selected>min</option>
                                                {minutee}
                                            </select>
                                        </td>
                                        <td>
                                            <select style={{ width: "100%" }} id="sbg_birth_am" value={this.state.sbg_birth_am} onChange={this.btimeamHandler} className="date_combo form-select" required>
                                                <option value="am" selected>Select</option>
                                                <option id="" value="सकाळ" >सकाळ</option>
                                                <option id="" value="दुपार" >दुपार</option>
                                                <option id="" value="संध्याकाळ" >संध्याकाळ </option>
                                                <option id="" value="रात्र" >रात्र</option>
                                            </select>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>






                        </div>

                        <div className="col-md-4">
                            <label htmlFor="putState" className="form-label">* रंग </label>
                            <select id="sbg_skin_complexion_id" value={this.state.sbg_skin_complexion_id} onChange={this.skinHandler} className="form-select" required>
                                <option value="f" selected>Choose...</option>
                                {varnaList}
                            </select>
                        </div>
                        <div className="col-md-4">
                            <label htmlFor="putState" className="form-label">* जन्म राशी </label>
                            <select id="sbg_zodiac_signs_id" value={this.state.sbg_zodiac_signs_id} onChange={this.zodiacHandler} className="form-select" required>
                                <option value="f" selected>Choose...</option>
                                {zediocListItem}
                            </select>
                        </div>
                        <div className="col-md-4">
                            <label htmlFor="putState" className="form-label">* उंची </label>
                            <select id="sbg_height_id" value={this.state.sbg_height_id} onChange={this.heightHandler} className="form-select" required>
                                <option value="f" selected>Choose...</option>
                                {heightListList}
                            </select>
                        </div>

                        <div className="col-md-4">
                            <label htmlFor="putState" className="form-label">* गोत्र  </label>
                            <select id="sbg_gotra_id" value={this.state.sbg_gotra_id} onChange={this.gotraHandler} className="form-select" required>
                                <option value="f" selected>Choose...</option>
                                {gotremListItem}
                            </select>
                        </div>
                        <div className="col-md-4">
                            <label htmlFor="putState" className="form-label">* मामकुळ </label>
                            <ReactTransliterate id="sbg_mama_kul" placeholder='मामकुळ' value={this.state.sbg_mama_kul} onChange={this.kulHandler} className="form-control" required />
                        </div>
                        <div className="col-md-4">
                            <label htmlFor="putState" className="form-label">* मामाचे गाव  </label>
                            <ReactTransliterate id="sbg_mama_place" placeholder='मामाचे गाव ' value={this.state.sbg_mama_place} onChange={this.mplaceHandler} className="form-control" required />
                        </div>


                        <div className="col-md-4">
                            <label htmlFor="putState" className="form-label">* वैवाहिक स्थिती   </label>
                            <select id="sbg_marital_status_id" value={this.state.sbg_marital_status_id} onChange={this.mrstatusHandler} className="form-select" required>
                                <option value="f" selected>Choose...</option>
                                {maritualList}
                            </select>
                        </div >

                        {this.state.aaptyaDiv ?
                            <div className="col-md-4">
                                <div className="container border-darken-1">

                                    <table className="bg-white text-lg-center pad2" cellPadding="3" cellSpacing="3">
                                        <tbody>
                                            <tr >
                                                <td className="bg-gray pt-2 pl-4">अपत्य</td>
                                                <td className="pt-2 ">संख्या</td>
                                                <td className="pt-2 ">वय</td>
                                            </tr>
                                            <tr>
                                                <td className="bg-gray pt-2 pl-4">मुलगा</td>
                                                <td><input type="text" maxLength="2" id="" value={this.state.sbg_aptya_boy_no} onChange={this.aptyaBoyNoHandler} className="txt_box " style={{ width: "100%" }} /></td>
                                                <td><input type="text" maxLength="8" id="" value={this.state.sbg_aptya_boy_age} onChange={this.aptyaBoyAgeHandler} className="txt_box" style={{ width: "100%" }} /></td>
                                            </tr>
                                            <tr>
                                                <td className="bg-gray pt-2 pl-4"> मुलगी</td>
                                                <td><input type="text" id="" maxLength="2" value={this.state.sbg_aptya_girl_no} onChange={this.aptyaGirlNoHandler} className="txt_box  mr-3" style={{ width: "100%" }} /></td>
                                                <td><input type="text" maxLength="8" id="" value={this.state.sbg_aptya_girl_age} onChange={this.aptyaGirlAgeHandler} className="txt_box  mr-3" style={{ width: "100%" }} /></td>
                                            </tr>
                                        </tbody>
                                    </table>

                                </div>
                            </div>
                            : null}




                        {this.state.vivahDateDiv ?
                            <div className="col-md-4">
                                <label htmlFor="putState" className="form-label">* विवाह तारीख ( उदा. 12/04/1900 )</label>
                                <input type="date" id="" value={this.state.sbg_gh_marriage_date} onChange={this.ghMarriageDateHandler} placeholder="dd/mm/yy" className="form-control" required />
                            </div>
                            : null}

                        {this.state.VibhktaDateDiv ?
                            <div className="col-md-4">
                                <label htmlFor="putState" className="form-label">विभक्त होण्याची तारीख अंदाजे ( उदा. 16/06/1902 ) </label>
                                <input type="date" id="" value={this.state.sbg_gh_vibhakta_date} onChange={this.vibhaktaDateHandler} placeholder="dd/mm/yy" className="form-control" />
                            </div>
                            : null}
                        {this.state.ghatspotDiv ?
                            <div className="col-md-4">
                                <label htmlFor="putState" className="form-label">घटस्फोटाची तारीख अंदाजे  ( उदा.30/11/1906) </label>
                                <input type="date" id="" value={this.state.sbg_gh_divorce_date} onChange={this.ghatspotHandler} placeholder="dd/mm/yy" className="form-control" required />
                            </div>
                            : null}
                        {this.state.vidhvaDateDiv ?
                            <div className="col-md-4">
                                <label htmlFor="putState" className="form-label">विधवा / विधुर होण्याची   तारीख ( उदा.30/11/1906)  </label>
                                <input type="date" id="" value={this.state.sbg_vidhva_date} onChange={this.vidhvaHandler} placeholder="dd/mm/yy" className="form-control" required />
                            </div>
                            : null}



                        <div className="col-md-4">
                            <label htmlFor="putState" className="form-label"> अपंगत्व / शाररिक दोष  </label>
                            <ReactTransliterate id="sbg_handicapped" value={this.state.sbg_handicapped} onChange={this.handicapHandler} className="form-control" required />
                        </div>
                        <div className="col-md-4">
                            <label htmlFor="putState" className="form-label"> मंगळ दोष   </label>
                            <select id="sbg_mangal_status_id" value={this.state.sbg_mangal_status_id} onChange={this.mangalstausHandler} className="form-select" required>

                                <option value="f" selected>Choose...</option>
                                {mangalListItem}
                            </select>
                        </div>
                        <div className="col-md-8">
                            <label for="inputEmail4" className="form-label">* अपेक्षा   </label>
                            <ReactTransliterate renderComponent={(props) => <textarea {...props} />} id="sbg_expectation" value={this.state.sbg_expectation} onChange={this.expectationHandler} className="form-control" placeholder="थोडक्यात वधू /वर विषयीच्या अपेक्षा टाकाव्यात " />
                            <span id="dataLimit"></span><span>{this.state.apekshaLength}/100</span>
                        </div>

                        <div className="col-12">

                            <button type="submit" className="btn btn-primary" onClick={(e) => (this.submitClick) ? this.submitClick(e) : null}>Save & Next ▶️</button>
                            <br></br>  <span className='text-danger font-weight-bold' id="error"></span> &nbsp;&nbsp;&nbsp;
                        </div>
                    </form>
                </div>



            </>
        )
    }
}



export default PersonalInfo
